module.exports = __webpack_public_path__ + "media/images/w_1-8d4f0d60ec5644c64af9cc3f020a7ecf.png";